import { Button } from '@heidi/design-system/button';
import { cn } from '@heidi/utils';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { ChangeScrollPanel } from './change-scroll-panel';

export const DetailsSection = ({
  open,
  onToggle,
  children,
  placeholder,
}: {
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
  /** Shown open in place of the details panel, for example a loading shimmer. */
  placeholder?: ReactNode;
}) => {
  const intl = useIntl();
  const Chevron = open ? ChevronDown : ChevronRight;
  return (
    <div className="-mt-2 flex flex-col gap-2 ps-12">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={onToggle}
        aria-expanded={open}
        data-testid="routine-proposal-details-toggle"
        className="!h-auto w-fit gap-1.5 !bg-transparent !p-0 font-normal text-text-secondary hover:!bg-transparent hover:text-text-primary active:!bg-transparent aria-expanded:!bg-transparent"
      >
        {intl.formatMessage({
          defaultMessage: 'Details',
          id: 'O8trvGnX8u',
          description: 'Toggle to expand the read-only details on a routine proposal',
        })}
        <Chevron className={cn('size-4', !open && 'rtl:-scale-x-100')} aria-hidden />
      </Button>
      {open ? (placeholder ?? <DetailsPanel>{children}</DetailsPanel>) : null}
    </div>
  );
};

const DetailsPanel = ({ children }: { children: ReactNode }) => (
  <ChangeScrollPanel
    surface="background-tertiary"
    className="rounded-lg bg-background-tertiary"
    scrollClassName="max-h-62 px-3.5 py-3"
    testIdPrefix="routine-proposal-details"
  >
    {children}
  </ChangeScrollPanel>
);
